<template>
  <v-main>
    <router-view />
    <loading />
    <!-- <dashboard-core-footer /> -->
  </v-main>
</template>

<script>
  import Loading from '@/views/dashboard/components/core/Loading'

  export default {
    name: 'DashboardCoreView',

    components: {
      /*  DashboardCoreFooter: () => import('./Footer'), */
      Loading,
    },
  }
</script>
